<script setup>
  const { to } = defineProps({ to: String, white: Boolean });
</script>

<!----------------------------------------------------------------------------->

<template>
  <NuxtLink :to="to" target="_self" :class="{ white }">
    <IconArrowSmall /><span><slot /></span>
  </NuxtLink>
</template>

<!----------------------------------------------------------------------------->

<style lang="scss" scoped>
  a {
    user-select: none;

    @include industry-demi(px(16));

    display: inline-flex;
    align-items: center;
    gap: px(12);

    &.white {
      color: $white;
    }

    :deep(svg) {
      path {
        fill: currentColor;
      }
    }

    @include fade('color', 0.22s);
    svg {
      transform: rotate(180deg);
      margin-top: px(-2);
    }

    @include hover {
      color: $red;
      @include fade('color', 0.08s);
    }

    @include break-medium {
      font-size: px(14);
      gap: px(7);
    }

    @include break-small {
      font-size: px(12);
    }
  }
</style>
